module.exports = __webpack_public_path__ + "static/media/logo.f6e95ecc.svg";